// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1G89_","header":"MessagesList_header__3UU7j","chat":"MessagesList_chat__3J_sJ"};